/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2020
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import Enum from './Enum';
//@import Enum (loadtime) // superclass

/**
 * <p>Java class for proParameterMode. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="proParameterMode"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}NMTOKEN"&gt; &lt;enumeration value="in"/&gt; &lt;enumeration value="out"/&gt; &lt;enumeration value="inout"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
 */
export default class ProParameterMode extends Enum{

	enumValue = null;

	/**
	 * Specifies an input parameter.
	 */
	static  IN = ProParameterMode.newLiteral("in");

	/**
	 * Specifies an output parameter.
	 */
	static  OUT = ProParameterMode.newLiteral("out");

	/**
	 * Specifies a parameter that is overwritten during execution.
	 */
	static  INOUT = ProParameterMode.newLiteral("inout");



	constructor(v) {
		super(v);
		this.enumValue = v;
	}

	static fromValue(v) {
		for (var i = 0; (i < ProParameterMode.values().length); ++i) {
			if (ProParameterMode.values()[i].enumValue == v) {
				return ProParameterMode.values()[i];
			}
		}
		throw new Error(v);
	}

	value() {
		return this.enumValue;
	}

	getResourceId() {
		return (("ProParameterMode" + "_") + this.value());
	}
}


// WEBPACK FOOTER //
// ./src/generated/ProParameterMode.js